import script from "./ResetAdminPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetAdminPassword.vue?vue&type=script&setup=true&lang=js"

import "./ResetAdminPassword.vue?vue&type=style&index=0&id=3de3a51c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de3a51c"]])

export default __exports__